import styled from "styled-components";

const RestaurantListStyles = styled.div`
  /* min-width: 1089px; */
  position: relative;
  width: 100%;

  .map-list-btn {
    display: none;
  }

  .restaurant-list-container {
    position: absolute;
    top: 20px;
    right: 12px;
    background: white;
    width: 400px;
    height: calc(100vh - 40px);
    border-radius: 30px;
    padding: 24px 18px;
    box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.1);
    z-index: 90;
    /* overflow: hidden; */
  }

  .restaurant-list {
    display: inline-block;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: 4px !important;
    scrollbar-color: #cdcdcd transparent;

    &__list-header {
      font-family: var(--header-font);
      font-weight: normal !important;
      font-size: 20px;
      padding: 0 0 8px 0;
      border-bottom: 2px solid var(--light-gray);
      margin-bottom: 24px;
      line-height: 26px;
    }

    /* width */
    ::-webkit-scrollbar {
      width: 8.5px;
      border-radius: 30px;
      margin-left: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: white;
      border-radius: 30px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #cdcdcd;
      border-radius: 30px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: var(--medium-gray);
    }
  }

  /* .search-results {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
    padding-bottom: 40px;
    margin-bottom: 30px;

    &__container {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    &__view-switch {
      display: none;
    }
  } */

  /* .search-map-box {
    height: calc(100vh);
    width: 100%;

    padding-left: 11px;
  } */

  .close-map-btn {
    display: none;
  }

  #search-map {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    height: 100vh;
    width: 100%;
    /* min-width: 786px !important; */
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .loading {
    width: 360px;
  }

  @media only screen and (max-width: 1075px) {
    /* #search-map {
      width: calc(960px - 550px - 40px);
    }

    .search-map-box {
      width: calc(960px - 550px - 40px);
      margin-left: 40px;
    } */
    /* .restaurant-list {
      position: relative;
      top: 38px;

      &__headings {
        width: 618px;
      }
    }

    .search-map-box {
      display: none;
      position: relative;
      padding-bottom: 38px;
      margin-left: 0;
      top: initial;
    }

    #search-map {
      top: 38px;
      width: 618px;
    }

    #map-list-button:checked ~ .restaurant-list {
      display: none;
    }

    #map-list-button:checked ~ .search-map-box {
      display: block;
      width: 618px;
      height: 600px;
    }

    #map-list-button:checked
      ~ .search-map-box
      > .mapbox-canvas-container
      > .mapbox-canvas {
      width: 618px;
      height: 600px;
    }

    .search-results {
      position: relative;
      top: -40px;
      width: 618px;
      margin-bottom: 30px;

      &__view-switch {
        display: inline-block;
        position: absolute;
        right: 0;
        top: -45px;
        cursor: pointer;
        font-size: 16px;
        line-height: normal;
        color: var(--off-black);
        letter-spacing: 0.99px;
        text-align: center;
        border: none;
        border-bottom: 1px var(--off-black) solid;
        padding-bottom: 5px;
        z-index: 1000;
      }
    } */
  }

  @media only screen and (max-width: 1165px) {
    /* .search-map-box {
      padding-left: 4px;
    } */
  }

  @media only screen and (max-width: 1157px) {
    /* .search-map-box {
      padding-left: 0px;
    } */
  }

  @media only screen and (max-width: 1145px) and (pointer: coarse) {
    min-width: initial;
    width: 100vw;

    .restaurant-list {
      padding-right: 0 !important;
    }

    .search-results__container {
      background: white;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
    }

    .restaurant-list-container {
      position: relative;
      right: 0;
      top: 0;
      width: 100vw;
      height: 100%;
      border-radius: 0;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      box-shadow: none;
      padding: 0 12px;
      padding-top: 20px;
    }

    #map-list-button:checked ~ .restaurant-list {
      display: none;
    }

    #map-list-button:checked ~ .search-map-box {
      display: block;
      position: fixed;
      margin-left: 0;
      margin-top: 0;
      width: 100vw;
      z-index: 9000000;
      height: 70vh;
      top: 30vh;
    }

    .map-full-screen {
      height: 100vh !important;
    }

    .map-container-full-screen {
      height: 100vh !important;
      top: 0 !important;
    }

    .close-map-btn {
      display: block;
      position: absolute;
      top: 12px;
      left: 12px;
      padding: 0;
      z-index: 900000;
      background: none;
      outline: none;
      border: none;
      box-shadow: none;
      color: var(--off-black);
      font-size: 20px;
      margin-top: 0;
    }
    */
      #map-list-button:checked
      ~ .search-map-box
      > .mapbox-canvas-container
      > .mapbox-canvas {
      width: 100%;
      height: 70vh;
    }

    #map-list-button:checked ~ .search-results__view-switch {
      display: none;
    }

    #details-label {
      display: block;
    }

    .loading {
      width: calc(100vw - 40px);
      max-width: 550px;
    }

    /* .restaurant-list {
      width: calc(100vw - 40px);
      max-width: 550px;
      position: relative;
      margin: 0;
      background: white;

      &__headings {
        width: calc(100vw - 40px);
        max-width: 550px;
        margin-top: 450px;
        padding-top: 50px;
        border-bottom: none;
        min-width: initial;
      }
    } */

    .search-results {
      flex-direction: column;
      align-items: center;
      width: 100%;
      min-width: initial;

      &__view-switch {
        /* display: block; */
        content: "";
        width: calc(100vw - 24px);
        /* max-width: 550px; */
        height: 70px;
        transform: translateX(12px);
        background-image: url("https://res.cloudinary.com/table-sage/image/upload/c_scale,w_974/v1614854857/maps/amsterdam_map_h7p2oi.png");
        background-position: center top;
        background-size: cover;
        border-radius: 60px;
        text-align: center;
        line-height: 28px;
        font-size: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 14px;
      }
    }

    #results-container {
      width: calc(100vw - 24px);
      margin: 0 auto;
    }

    .search-map-box {
      display: none;
    }

    #search-map {
      position: relative;
      content: "";
      height: 70vh;
      width: 100vw;
      margin: 0 auto;
      min-width: initial;
      //lots of code needed for cross browser compatibility of the border radius
      border-radius: 30px;
      -webkit-border-radius: 16px;
      -moz-border-radius: 16px;
      transform: translate3d(0, 0, 0);
      -webkit-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      //the following may not be necessary
      overflow: hidden;
      -webkit-overflow: hidden;
      -moz-overflow: hidden;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      border-bottom-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
`;

export default RestaurantListStyles;
